// The user limit of a company that has none (Usage & Limits Control: users not enforced), as stored in max_members.
export const UNLIMITED_MEMBERS = 1000000;

/** A user limit for display: "10", or "Unlimited". */
export const seatLimit = (n) => (n >= UNLIMITED_MEMBERS ? 'Unlimited' : n);

/** "3 / 10", or "3" when there's no limit. */
export const seatsUsed = (used, limit) => (limit >= UNLIMITED_MEMBERS ? `${used}` : `${used} / ${limit}`);
